export const DEFAULT_DATATABLE = {
  isLoading: false,
  itemsPerPage: 20,
  itemsPerPageOptions: [20],
  totalItems: 100,
  items: [],
};
